import {
  getImpactIcon,
  getSeverityIcon,
  getStatusChip,
} from '../helper-utils/riskRegisterHelper';

const RiskRegisterConstants = {
  MAIN_PAGE: {
    TITLE: 'Strategy & Insights Board',
    ADD_RISK: 'Add Insight',
    RISK_TITLE: 'Title',
    DESCRIPTION: 'Description',
    DATE_IDENTIFIED: 'Date Identified',
    IMPACT_TYPE: 'Impact Type',
    RISK_STATUS: 'Status',
    SEVERITY_LEVEL: 'Severity Level',
    RISK_SOURCE: 'Source',
    ATTACHMENTS: 'Attachments',
    DATE_FORMAT: 'MMMM D, yyyy',
    IMPACT_OPTIONS: [
      getImpactIcon('Compliance'),
      getImpactIcon('Cost'),
      getImpactIcon('Care'),
    ],
    IMPACT_VALUES: ['Compliance', 'Cost', 'Care'],
    STATUS_OPTIONS: [
      getStatusChip('New'),
      getStatusChip('Planned'),
      getStatusChip('In Progress'),
      getStatusChip('Mitigated'),
      getStatusChip('Accepted'),
    ],
    STATUS_VALUES: ['New', 'Planned', 'In Progress', 'Mitigated', 'Accepted'],
    SEVERITY_LEVEL_OPTIONS: [
      getSeverityIcon('Low'),
      getSeverityIcon('Medium'),
      getSeverityIcon('High'),
    ],
    SEVERITY_LEVEL_VALUES: ['Low', 'Medium', 'High'],
    UPLOAD: 'Upload',
    UPLOADING: 'Uploading',
    CANCEL: 'CANCEL',
    START_DATE: 'Start Date',
    MITIGATION_ACTIVITY: 'Mitigation Activity',
    OWNER: 'Owner',
    TRACKER: 'Tracker',
    DELAY_REASON: 'Reason for Delay',
    ACCEPTED_INFO_TITLE: 'You have acknowledged the issue.',
    ACCEPTANCE_INFO_SUB: 'You’ve decided to close this issue without action. ',
    ACCEPTANCE_REASON: 'Reason for Acceptance',
    OUTCOME: 'Outcome of Activity',
    FUTURE_MITIGATION: 'Create a Mitigation Plan for Future',
    PLAN_MITIGATION: 'When do you plan to start this mitigation?',
    TABLE1_TITLE: 'New Items',
    NO_NEW_RISK: 'No New Items Yet',
    NO_NEW_RISK_SUB:
      "You haven't added or received any new insights or strategies yet.",
    ADD_NEW_RISK: 'Add New Insight / Strategy',
    TABLE2_TITLE: 'Active Plans',
    NO_INPROGRESS_RISK: 'No Active Plans',
    NO_INPROGRESS_RISK_SUB:
      "Plans you're actively working on will appear here.",
    ADD_NEW_RISK_MITIGATION: 'Add New Insight Mitigation',
    TAB_LIST: [
      'New Items & Active Plans',
      'Queued for Action',
      'Completed Items',
    ],
    TABLE3_TITLE: 'Queued for Action',
    NO_RISK_PLANNED: 'Nothing Scheduled Yet',
    NO_RISK_PLANNED_SUB: 'Items planned for future action will be shown here.',
    TABLE4_TITLE: 'Completed Items',
    NO_RISK_MITIGATED: 'No Completed Items',
    NO_RISK_MITIGATED_SUB:
      "Items that you've successfully completed will appear here",
    TABLE_5_TITLE: 'Acknowledged – No Action',
    NO_RISK_ACCEPTED: 'No Acknowledged Items',
    NO_RISK_ACCEPTED_SUB:
      "Items you've reviewed and decided not to act on will be listed here.",
    SOURCE_REPORT: 'Source Report',
    ADD_MITIGATION: 'Add More Activities',
    SAVE: 'Save',
    TABLE_MENU: ['Delete'],
    DELETE: 'Delete INSIGHT',
    DELETE_DESC: 'Are you sure you want to delete this insight?',
    CONFIRM: 'Confirm',
  },
  ACKNOWLEDGE_RISK: {
    TITLE: 'Action Plan Initiation',
    sUBTITLE:
      'Please complete the details below to establish an action plan for this insight.',
    QUESTION: 'What do you want to do with this insight?',
    MITIGATE: 'Initiate Action Plan',
    ACCEPT: 'Acknowledge',
    SAVE_PREFERENCE: 'Save my preference',
    DOWNLOAD_REPORT: 'Download Full Report',
    RISK_DECISION: 'What do you want to do with this insight?',
    PLAN_MITIGATION: 'When do you want to start working on the insight??',
    START_FROM: 'Start From',
  },
  DETAILS_WINDOW: {
    DETAILS: 'Details',
    IMPACT: 'Impact',
    STATUS: 'Status',
    SEVERITY: 'Severity',
    SOURCE: 'Source',
    ACTIVITY: 'Mitigation Activity',
    NO_ACTIVITIES: 'Activities have not been created yet',
    COMMENTS: 'Comments',
    ADD_COMMENT: 'Add a Comment',
    SENDING: 'Sending',
    UPLOADING: 'Uploading',
    UPLOAD: 'Upload',
    CONNECTED: 'Connected To',
  },
};
export default RiskRegisterConstants;
